/* ==========================================================================
   QUESTION BANK — PART 3: ATI SPECIALTY PROCTORED EXAMS
   Original items written against each ATI content area.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.XP_BANK) window.XP_BANK = { items: [], stimuli: {} };
  var items = window.XP_BANK.items;

  var R = {
    statpearls: { t: 'StatPearls (NCBI Bookshelf) — peer-reviewed clinical reference', u: 'https://www.ncbi.nlm.nih.gov/books/NBK430685/', k: 'scholarly' },
    openstaxAP: { t: 'OpenStax — Anatomy & Physiology 2e', u: 'https://openstax.org/details/books/anatomy-and-physiology-2e', k: 'scholarly' },
    cdcPrecautions: { t: 'CDC — Standard & Transmission-Based Precautions', u: 'https://www.cdc.gov/infection-control/hcp/basics/standard-precautions.html', k: 'scholarly' },
    cdcImm: { t: 'CDC — Immunization Schedules', u: 'https://www.cdc.gov/vaccines/hcp/imz-schedules/', k: 'scholarly' },
    dietary: { t: 'Dietary Guidelines for Americans', u: 'https://www.dietaryguidelines.gov/', k: 'scholarly' },
    ncbi: { t: 'NCBI Bookshelf — open-access biomedical texts', u: 'https://www.ncbi.nlm.nih.gov/books/', k: 'scholarly' }
  };
  function yt(q, label) {
    return { t: label || ('YouTube — ' + q), u: 'https://www.youtube.com/results?search_query=' + encodeURIComponent(q), k: 'video' };
  }

  var svgPrecautions =
    '<svg viewBox="0 0 460 250" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.h{font:700 12px sans-serif;fill:#1d2b2a}.l{font:600 11px sans-serif;fill:#fff}.c{font:10px sans-serif;fill:#1d2b2a}</style>' +
    '<text class="h" x="230" y="18" text-anchor="middle">Transmission-based precautions</text>' +
    '<rect x="12" y="32" width="140" height="200" rx="8" fill="#f2faf8" stroke="#3a7bd5" stroke-width="2"/>' +
    '<rect x="12" y="32" width="140" height="26" rx="8" fill="#3a7bd5"/>' +
    '<text class="l" x="82" y="50" text-anchor="middle">CONTACT</text>' +
    '<text class="c" x="24" y="80">Gown + gloves</text>' +
    '<text class="c" x="24" y="100">Private room</text>' +
    '<text class="c" x="24" y="120">Dedicated equipment</text>' +
    '<text class="c" x="24" y="148" font-weight="700">Examples</text>' +
    '<text class="c" x="24" y="166">C. difficile</text>' +
    '<text class="c" x="24" y="182">MRSA / VRE</text>' +
    '<text class="c" x="24" y="198">Scabies</text>' +
    '<text class="c" x="24" y="218">RSV</text>' +
    '<rect x="162" y="32" width="140" height="200" rx="8" fill="#f2faf8" stroke="#1b7f52" stroke-width="2"/>' +
    '<rect x="162" y="32" width="140" height="26" rx="8" fill="#1b7f52"/>' +
    '<text class="l" x="232" y="50" text-anchor="middle">DROPLET</text>' +
    '<text class="c" x="174" y="80">Surgical mask</text>' +
    '<text class="c" x="174" y="100">Private room</text>' +
    '<text class="c" x="174" y="120">Mask patient to move</text>' +
    '<text class="c" x="174" y="148" font-weight="700">Examples</text>' +
    '<text class="c" x="174" y="166">Influenza</text>' +
    '<text class="c" x="174" y="182">Pertussis</text>' +
    '<text class="c" x="174" y="198">Meningitis</text>' +
    '<text class="c" x="174" y="218">Mumps / rubella</text>' +
    '<rect x="312" y="32" width="140" height="200" rx="8" fill="#f2faf8" stroke="#b3261e" stroke-width="2"/>' +
    '<rect x="312" y="32" width="140" height="26" rx="8" fill="#b3261e"/>' +
    '<text class="l" x="382" y="50" text-anchor="middle">AIRBORNE</text>' +
    '<text class="c" x="324" y="80">N95 respirator</text>' +
    '<text class="c" x="324" y="100">Negative pressure</text>' +
    '<text class="c" x="324" y="120">Door closed</text>' +
    '<text class="c" x="324" y="148" font-weight="700">Examples</text>' +
    '<text class="c" x="324" y="166">Tuberculosis</text>' +
    '<text class="c" x="324" y="182">Measles</text>' +
    '<text class="c" x="324" y="198">Varicella</text>' +
    '<text class="c" x="324" y="218">Disseminated zoster</text>' +
    '</svg>';

  var svgFundal =
    '<svg viewBox="0 0 420 240" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.l{font:600 11px sans-serif;fill:#1d2b2a}.c{font:10px sans-serif;fill:#63807d}</style>' +
    '<ellipse cx="150" cy="130" rx="72" ry="98" fill="#fdf2f4" stroke="#b3261e" stroke-width="2"/>' +
    '<line x1="60" y1="40" x2="250" y2="40" stroke="#c9a227" stroke-width="2" stroke-dasharray="5 4"/>' +
    '<text class="l" x="262" y="44">Umbilicus (U)</text>' +
    '<text class="c" x="262" y="58">= immediately after birth</text>' +
    '<line x1="60" y1="72" x2="250" y2="72" stroke="#004B49" stroke-width="2"/>' +
    '<text class="l" x="262" y="76">U − 1 = day 1</text>' +
    '<line x1="60" y1="104" x2="250" y2="104" stroke="#004B49" stroke-width="2"/>' +
    '<text class="l" x="262" y="108">U − 2 = day 2</text>' +
    '<line x1="60" y1="136" x2="250" y2="136" stroke="#004B49" stroke-width="2"/>' +
    '<text class="l" x="262" y="140">U − 3 = day 3</text>' +
    '<text class="c" x="150" y="228" text-anchor="middle">Fundus descends about 1 cm per day and</text>' +
    '<text class="c" x="150" y="242" text-anchor="middle">should be firm and midline.</text>' +
    '</svg>';

  items.push(
    /* ---------------- ATI PHARMACOLOGY ---------------- */
    {
      id: 'atiph-01', exam: 'ati-pharmacology', section: 'cardio', difficulty: 'hard', type: 'mcq',
      q: 'A client taking warfarin should be taught to keep intake of which nutrient consistent?',
      opts: ['Vitamin C', 'Vitamin K', 'Calcium', 'Potassium'],
      a: 1,
      why: '<p>Warfarin works by inhibiting the recycling of <strong>vitamin K</strong>, which is required to make clotting factors II, VII, IX and X. Swinging intake up or down swings the INR with it.</p>' +
        '<p>The teaching point is <strong>consistency, not avoidance</strong>. Clients are often wrongly told to stop eating leafy greens entirely; the correct instruction is to eat a steady amount week to week so the dose can be titrated against it.</p>' +
        '<p>Vitamin K is also the antidote for warfarin over-anticoagulation — a detail that gets tested directly.</p>',
      refs: [R.statpearls, yt('warfarin vitamin K INR teaching nursing', 'Video — Warfarin and vitamin K')]
    },
    {
      id: 'atiph-02', exam: 'ati-pharmacology', section: 'endocrine', difficulty: 'hard', type: 'mcq',
      q: 'A client receives regular insulin at 0730. When should the nurse be most alert for hypoglycaemia?',
      opts: ['0745 to 0800', '0930 to 1030', '1500 to 1700', '2200 to 0200'],
      a: 1,
      why: '<p><strong>Regular (short-acting) insulin</strong> peaks at roughly <strong>2 to 4 hours</strong> after administration. Given at 0730, the peak — and the greatest hypoglycaemia risk — falls around 0930 to 1130.</p>' +
        '<p>The profiles worth knowing cold:</p>' +
        '<ul><li><strong>Rapid (lispro, aspart)</strong> — onset 15 min, peak 1 to 2 h</li>' +
        '<li><strong>Regular</strong> — onset 30 to 60 min, peak 2 to 4 h</li>' +
        '<li><strong>NPH</strong> — peak 4 to 12 h</li>' +
        '<li><strong>Glargine / detemir</strong> — essentially peakless</li></ul>' +
        '<p>Peak time is the single most tested insulin fact, because it determines when meals and monitoring must happen.</p>',
      refs: [R.statpearls, yt('insulin onset peak duration chart nursing', 'Video — Insulin onset, peak and duration')]
    },
    {
      id: 'atiph-03', exam: 'ati-pharmacology', section: 'anti', difficulty: 'moderate', type: 'mcq',
      q: 'Which laboratory value most requires monitoring in a client receiving IV vancomycin?',
      opts: ['Serum creatinine', 'Serum amylase', 'Total bilirubin', 'Serum calcium'],
      a: 0,
      why: '<p>Vancomycin is <strong>nephrotoxic and ototoxic</strong>, so <strong>serum creatinine</strong> — a marker of renal function — is monitored alongside trough levels.</p>' +
        '<p>Also expected: assess hearing, and infuse over at least 60 minutes. Rapid infusion causes the histamine-mediated flushing reaction of the face and torso sometimes called "red man syndrome" — that is an infusion-rate problem, not an allergy, and it resolves by slowing the rate.</p>' +
        '<p>The aminoglycosides (gentamicin, tobramycin) share this nephro/ototoxic profile and are monitored the same way.</p>',
      refs: [R.statpearls, yt('vancomycin nursing considerations trough nephrotoxicity', 'Video — Vancomycin monitoring')]
    },
    {
      id: 'atiph-04', exam: 'ati-pharmacology', section: 'neuro', difficulty: 'moderate', type: 'mcq',
      q: 'A client on lithium develops vomiting, diarrhoea, coarse tremor and confusion. The nurse should suspect that lithium levels are:',
      opts: ['Subtherapeutic', 'Therapeutic', 'Toxic', 'Unaffected by these symptoms'],
      a: 2,
      why: '<p>These are classic signs of <strong>lithium toxicity</strong>. Lithium has an exceptionally narrow therapeutic index — maintenance is 0.6 to 1.2 mEq/L, and toxicity begins above about 1.5 mEq/L.</p>' +
        '<p>Toxicity progresses predictably: GI upset and coarse tremor first, then confusion and ataxia, then seizures and cardiovascular collapse. A <em>fine</em> tremor can be an expected early side effect; a <em>coarse</em> tremor is a warning sign.</p>' +
        '<p>The teaching that prevents it: maintain steady sodium and fluid intake. Dehydration, low sodium, NSAIDs and thiazide diuretics all raise lithium levels.</p>',
      refs: [R.statpearls, yt('lithium toxicity signs nursing therapeutic range', 'Video — Lithium toxicity')]
    },

    /* ---------------- ATI MED-SURG ---------------- */
    {
      id: 'atims-01', exam: 'ati-med-surg-rn', section: 'cardio', difficulty: 'hard', type: 'mcq',
      q: 'Which finding in a client with left-sided heart failure should the nurse report immediately?',
      opts: [
        'Bilateral ankle oedema',
        'Pink frothy sputum with crackles throughout both lung fields',
        'Jugular venous distension',
        'Weight gain of 0.5 kg over one week'
      ],
      a: 1,
      why: '<p><strong>Pink frothy sputum with widespread crackles</strong> is acute pulmonary oedema — a medical emergency. Left-sided failure backs blood up into the pulmonary circulation, and fluid is now flooding the alveoli.</p>' +
        '<p>Sort the two sides by where the fluid backs up: <strong>left-sided failure goes to the lungs</strong> (dyspnoea, orthopnoea, crackles, frothy sputum), <strong>right-sided goes to the body</strong> (peripheral oedema, JVD, hepatomegaly, ascites).</p>' +
        '<p>Options A and C are right-sided findings and expected in chronic disease. Half a kilogram over a week is not the threshold — 1 kg in 24 hours or 2.5 kg in a week is what triggers a call.</p>',
      refs: [R.statpearls, yt('left vs right sided heart failure symptoms nursing', 'Video — Left vs right heart failure')]
    },
    {
      id: 'atims-02', exam: 'ati-med-surg-rn', section: 'renal', difficulty: 'hard', type: 'mcq',
      q: 'A client presents with blood glucose 620 mg/dL, serum osmolality 340 mOsm/kg, and no ketones in the urine. This picture is most consistent with:',
      opts: [
        'Diabetic ketoacidosis',
        'Hyperosmolar hyperglycaemic state',
        'Hypoglycaemia',
        'Syndrome of inappropriate ADH'
      ],
      a: 1,
      why: '<p><strong>Hyperosmolar hyperglycaemic state (HHS)</strong> is defined by very high glucose (often above 600), markedly raised osmolality, and <strong>minimal or absent ketones</strong>.</p>' +
        '<p>The distinction from DKA is the presence of residual insulin. In type 2 diabetes there is enough insulin to suppress lipolysis — so no significant ketogenesis — but not enough to control glucose. DKA, by contrast, shows ketones, an anion-gap metabolic acidosis, and Kussmaul respirations.</p>' +
        '<p>HHS carries a higher mortality than DKA because the dehydration is more profound and it develops more insidiously.</p>',
      refs: [R.statpearls, yt('DKA vs HHS comparison nursing', 'Video — DKA versus HHS')]
    },
    {
      id: 'atims-03', exam: 'ati-med-surg-rn', section: 'renal', difficulty: 'moderate', type: 'mcq',
      q: 'A client with chronic kidney disease has a potassium of 6.4 mEq/L. Which assessment takes priority?',
      opts: ['Bowel sounds', 'Cardiac rhythm', 'Skin turgor', 'Deep tendon reflexes'],
      a: 1,
      why: '<p>Potassium governs cardiac membrane excitability. At 6.4 mEq/L the client is at real risk of <strong>peaked T waves, widened QRS, and ventricular dysrhythmias or arrest</strong>, so <strong>cardiac rhythm</strong> is the priority assessment.</p>' +
        '<p>Hyperkalaemia does cause GI hyperactivity and muscle weakness, so the other options are not wrong — they are simply not lethal. Prioritisation items reward finding the assessment tied to the fastest route to death.</p>' +
        '<p>Normal potassium is 3.5 to 5.0 mEq/L.</p>',
      refs: [R.statpearls, yt('hyperkalemia ECG changes peaked T waves nursing', 'Video — Hyperkalaemia and the ECG')]
    },

    /* ---------------- ATI ANATOMY & PHYSIOLOGY ---------------- */
    {
      id: 'atiap-01', exam: 'ati-anatomy', section: 'neuro', difficulty: 'moderate', type: 'mcq',
      q: 'Damage to the cerebellum would most directly impair:',
      opts: [
        'Language comprehension',
        'Balance and coordination of voluntary movement',
        'Regulation of body temperature',
        'Formation of new long-term memories'
      ],
      a: 1,
      why: '<p>The <strong>cerebellum</strong> coordinates and fine-tunes voluntary movement, posture and balance. Damage produces ataxia, intention tremor and a wide-based unsteady gait.</p>' +
        '<p>The other functions map elsewhere: language comprehension to <strong>Wernicke\'s area</strong> in the temporal lobe; temperature regulation to the <strong>hypothalamus</strong>; consolidation of new long-term memory to the <strong>hippocampus</strong>.</p>' +
        '<p>A useful frame: the cerebellum does not <em>initiate</em> movement — the motor cortex does. The cerebellum makes it smooth.</p>',
      refs: [R.openstaxAP, yt('cerebellum function ataxia neuroanatomy', 'Video — Cerebellar function')]
    },
    {
      id: 'atiap-02', exam: 'ati-anatomy', section: 'cardio-resp', difficulty: 'moderate', type: 'mcq',
      q: 'The primary stimulus driving respiratory rate in a healthy adult is:',
      opts: [
        'Falling arterial oxygen',
        'Rising arterial carbon dioxide',
        'Falling blood glucose',
        'Rising body temperature'
      ],
      a: 1,
      why: '<p>Central chemoreceptors in the medulla respond to <strong>rising CO₂</strong> — strictly, to the fall in cerebrospinal fluid pH that CO₂ produces. This is the dominant respiratory drive in health.</p>' +
        '<p>The hypoxic drive, mediated by peripheral chemoreceptors in the carotid and aortic bodies, only becomes significant when PaO₂ falls below about 60 mm Hg.</p>' +
        '<p>This underpins the classic caution in chronic CO₂ retention: some clients with advanced COPD rely more on the hypoxic drive, so high-flow oxygen requires careful monitoring.</p>',
      refs: [R.openstaxAP, yt('respiratory drive central chemoreceptors CO2 physiology', 'Video — Control of ventilation')]
    },
    {
      id: 'atiap-03', exam: 'ati-anatomy', section: 'musculo', difficulty: 'moderate', type: 'mcq',
      q: 'Which term describes movement of a limb away from the midline of the body?',
      opts: ['Adduction', 'Abduction', 'Flexion', 'Pronation'],
      a: 1,
      why: '<p><strong>Abduction</strong> moves a part <em>away</em> from the midline. The memory hook that works: to <em>abduct</em> is to take away.</p>' +
        '<p><strong>Adduction</strong> is the opposite — think "adding" the limb back to the body.</p>' +
        '<p><strong>Flexion</strong> decreases a joint angle; <strong>pronation</strong> rotates the forearm so the palm faces downward or backward.</p>',
      refs: [R.openstaxAP]
    },

    /* ---------------- ATI FUNDAMENTALS ---------------- */
    {
      id: 'atifu-01', exam: 'ati-fundamentals', section: 'safety', difficulty: 'moderate', type: 'mcq',
      q: 'A client is admitted with suspected pulmonary tuberculosis. Which precautions should the nurse implement?',
      opts: [
        'Standard precautions only',
        'Contact precautions with gown and gloves',
        'Droplet precautions with a surgical mask',
        'Airborne precautions with an N95 respirator and negative-pressure room'
      ],
      a: 3,
      why: '<p>Tuberculosis spreads by droplet nuclei small enough to remain suspended in air for hours, so it requires <strong>airborne precautions</strong>: a fit-tested <strong>N95 respirator</strong>, a <strong>negative-pressure room</strong>, and the door kept closed.</p>' +
        '<p>The three airborne diseases worth memorising are captured by <strong>"My Chicken Hatches TB"</strong> — Measles, Chickenpox (varicella), Herpes zoster disseminated, TB.</p>' +
        '<p>A surgical mask is insufficient because it does not filter particles this small or seal to the face.</p>',
      visual: svgPrecautions, caption: 'The three transmission-based precaution categories, their PPE and their classic examples.',
      refs: [R.cdcPrecautions, yt('airborne droplet contact precautions nursing mnemonic', 'Video — Isolation precautions')]
    },
    {
      id: 'atifu-02', exam: 'ati-fundamentals', section: 'safety', difficulty: 'moderate', type: 'mcq',
      q: 'When transferring a client from bed to chair, the nurse should position the chair:',
      opts: [
        'On the client\'s weaker side, facing away from the bed',
        'On the client\'s stronger side, at a slight angle to the bed',
        'Directly at the foot of the bed',
        'Wherever there is most room to manoeuvre'
      ],
      a: 1,
      why: '<p>Place the chair on the client\'s <strong>stronger side</strong> so they can bear weight and pivot toward the side that works, and angle it to the bed so the pivot arc is short.</p>' +
        '<p>Also expected: lock the wheels on both bed and chair, lower the bed so the client\'s feet reach the floor, apply non-skid footwear, and use a gait belt.</p>' +
        '<p>The underlying principle appears throughout fundamentals — <strong>move toward strength</strong>. It applies to transfers, to cane use (cane on the strong side), and to stair climbing.</p>',
      refs: [yt('safe patient transfer bed to chair nursing technique', 'Video — Safe transfer technique')]
    },
    {
      id: 'atifu-03', exam: 'ati-fundamentals', section: 'process', difficulty: 'easy', type: 'mcq',
      q: 'Which sequence is correct for abdominal assessment?',
      opts: [
        'Inspection, palpation, percussion, auscultation',
        'Inspection, auscultation, percussion, palpation',
        'Auscultation, inspection, palpation, percussion',
        'Palpation, inspection, auscultation, percussion'
      ],
      a: 1,
      why: '<p>The abdomen is the one region where the standard order changes. It is <strong>inspect, auscultate, percuss, palpate</strong>.</p>' +
        '<p>Auscultation moves ahead of percussion and palpation because touching the abdomen <strong>alters bowel motility</strong> — palpate first and the bowel sounds you then hear are not the client\'s baseline.</p>' +
        '<p>Everywhere else on the body the sequence is inspect, palpate, percuss, auscultate. Examiners test this specific exception often.</p>',
      refs: [yt('abdominal assessment sequence auscultation before palpation', 'Video — Abdominal assessment order')]
    },

    /* ---------------- ATI MATERNAL-NEWBORN ---------------- */
    {
      id: 'atimn-01', exam: 'ati-maternal', section: 'post', difficulty: 'moderate', type: 'mcq',
      q: 'Two hours after a vaginal birth the nurse finds the fundus boggy and displaced to the right of midline. The first action is to:',
      opts: [
        'Massage the fundus',
        'Assist the client to empty her bladder',
        'Administer oxytocin as ordered',
        'Notify the provider immediately'
      ],
      a: 0,
      why: '<p>A <strong>boggy fundus</strong> means uterine atony, and atony is the leading cause of early postpartum haemorrhage. The first action is <strong>fundal massage</strong> — it is immediate, non-invasive and often enough on its own.</p>' +
        '<p>Displacement to the right is the clue that a <strong>full bladder</strong> is preventing contraction, so emptying it is the necessary next step. But massage comes first because it addresses the bleeding now.</p>' +
        '<p>Oxytocin follows if massage fails; notifying the provider is appropriate but is not the first <em>nursing</em> action.</p>',
      visual: svgFundal, caption: 'Expected fundal descent — about one fingerbreadth per postpartum day, firm and midline.',
      refs: [R.statpearls, yt('boggy fundus postpartum hemorrhage nursing intervention', 'Video — Fundal assessment and atony')]
    },
    {
      id: 'atimn-02', exam: 'ati-maternal', section: 'newborn', difficulty: 'moderate', type: 'mcq',
      q: 'A newborn at one minute has a heart rate of 130, a strong cry, active motion, a grimace on suction, and a pink body with blue extremities. What is the Apgar score?',
      opts: ['7', '8', '9', '10'],
      a: 2,
      why: '<p>Score each of the five parameters 0 to 2:</p>' +
        '<ul><li>Heart rate over 100 → <strong>2</strong></li>' +
        '<li>Strong cry → <strong>2</strong></li>' +
        '<li>Active motion → <strong>2</strong></li>' +
        '<li>Grimace only → <strong>1</strong></li>' +
        '<li>Acrocyanosis (pink body, blue extremities) → <strong>1</strong></li></ul>' +
        '<p>Total = <strong>9</strong>.</p>' +
        '<p>Acrocyanosis is normal in the first 24 hours and is the single most common reason a healthy newborn does not score 10. A score of 7 or above is reassuring.</p>',
      refs: [R.statpearls, yt('APGAR score explained newborn assessment', 'Video — Scoring the Apgar')]
    },
    {
      id: 'atimn-03', exam: 'ati-maternal', section: 'ante', difficulty: 'hard', type: 'mcq',
      q: 'A client at 34 weeks reports a severe headache, visual changes and epigastric pain. BP is 168/112. The nurse should anticipate administering:',
      opts: [
        'Betamethasone only',
        'Magnesium sulfate',
        'Oxytocin',
        'Terbutaline'
      ],
      a: 1,
      why: '<p>This is <strong>severe pre-eclampsia</strong> with neurological and hepatic warning signs. <strong>Magnesium sulfate</strong> is given for <strong>seizure prophylaxis</strong> — it prevents progression to eclampsia.</p>' +
        '<p>Epigastric or right-upper-quadrant pain is the sign not to miss: it reflects hepatic capsule distension and may signal HELLP syndrome.</p>' +
        '<p>Monitor for magnesium toxicity — loss of deep tendon reflexes first, then respiratory depression, then cardiac arrest. Keep <strong>calcium gluconate</strong> at the bedside as the antidote. Betamethasone may well be given for fetal lung maturity, but it is not the priority here.</p>',
      refs: [R.statpearls, yt('magnesium sulfate preeclampsia nursing toxicity calcium gluconate', 'Video — Magnesium sulfate in pre-eclampsia')]
    },

    /* ---------------- ATI PEDIATRIC ---------------- */
    {
      id: 'atipd-01', exam: 'ati-pediatric', section: 'growth', difficulty: 'moderate', type: 'mcq',
      q: 'Which developmental milestone would the nurse expect a healthy 12-month-old to have achieved?',
      opts: [
        'Walking up stairs alternating feet',
        'Pulling to stand and cruising along furniture',
        'Speaking in three-word sentences',
        'Riding a tricycle'
      ],
      a: 1,
      why: '<p>By <strong>12 months</strong> most infants pull to stand and cruise; many take first independent steps between 12 and 15 months.</p>' +
        '<p>The others belong to later ages: three-word sentences around <strong>3 years</strong>, tricycle riding around <strong>3 years</strong>, alternating feet on stairs around <strong>4 years</strong>.</p>' +
        '<p>Anchor points that carry most paediatric items: sits unsupported at 6 months, crawls at 9, walks at 12, runs at 2 years, and birth weight triples by 12 months.</p>',
      refs: [{ t: 'CDC — Developmental Milestones', u: 'https://www.cdc.gov/ncbddd/actearly/milestones/index.html', k: 'scholarly' }]
    },
    {
      id: 'atipd-02', exam: 'ati-pediatric', section: 'resp', difficulty: 'hard', type: 'mcq',
      q: 'A child with suspected epiglottitis is drooling, sitting upright and leaning forward, and appears anxious. The nurse should:',
      opts: [
        'Examine the throat with a tongue depressor',
        'Obtain a throat culture',
        'Avoid examining the throat and prepare for possible intubation',
        'Place the child supine to improve assessment'
      ],
      a: 2,
      why: '<p><strong>Never inspect the throat in suspected epiglottitis.</strong> Any manipulation — a tongue depressor, a swab — can trigger laryngospasm and complete airway obstruction.</p>' +
        '<p>Keep the child calm, in whatever position they have chosen, and prepare for intubation with skilled airway support available.</p>' +
        '<p>The classic presentation is the <strong>four Ds</strong>: drooling, dysphagia, dysphonia and distress, with the child in the tripod position. Laying the child supine can also occlude the airway, making option D actively dangerous.</p>',
      refs: [R.statpearls, yt('epiglottitis pediatric tripod position nursing airway', 'Video — Paediatric epiglottitis')]
    },
    {
      id: 'atipd-03', exam: 'ati-pediatric', section: 'safety', difficulty: 'moderate', type: 'entry',
      q: 'A child weighs 44 lb. The safe range for a medication is 5 to 10 mg/kg/dose. What is the maximum safe single dose in milligrams?',
      a: 200, tol: 1,
      why: '<p>Convert first: 44 lb ÷ 2.2 = <strong>20 kg</strong>.</p>' +
        '<p>Maximum = 20 kg × 10 mg = <strong>200 mg per dose</strong>. (The minimum would be 20 × 5 = 100 mg.)</p>' +
        '<p>Safe-dose-range items are asking whether you can defend giving the dose. If the prescribed amount falls outside the calculated range, the correct action is to hold it and contact the prescriber — never to give a partial dose.</p>',
      refs: [yt('safe dosage range pediatric mg kg nursing calculation', 'Video — Safe dose range')]
    },

    /* ---------------- ATI MENTAL HEALTH ---------------- */
    {
      id: 'atimh-01', exam: 'ati-mental-health', section: 'crisis', difficulty: 'hard', type: 'mcq',
      q: 'A client with depression suddenly appears bright, calm and energetic after weeks of low mood. The nurse should recognise this as:',
      opts: [
        'Evidence the antidepressant is working',
        'A possible warning sign of increased suicide risk',
        'An expected sign of full recovery',
        'A reason to reduce observation frequency'
      ],
      a: 1,
      why: '<p>A sudden lift in mood in severe depression is a recognised <strong>warning sign</strong>, not simple improvement. It can mean the client has reached a decision and feels relief — and now has the energy to act on a plan that profound psychomotor retardation previously prevented.</p>' +
        '<p>The correct response is to <strong>increase</strong> observation and ask directly about suicidal thoughts, plan and means. Asking directly does not plant the idea; it is protective and is what the exam expects.</p>' +
        '<p>Genuine recovery is gradual and matches other changes in sleep, appetite and engagement. An abrupt reversal warrants suspicion.</p>',
      refs: [{ t: '988 Suicide & Crisis Lifeline', u: 'https://988lifeline.org/', k: 'reference' }, R.statpearls]
    },
    {
      id: 'atimh-02', exam: 'ati-mental-health', section: 'therapeutic', difficulty: 'moderate', type: 'mcq',
      q: 'A client experiencing auditory hallucinations says, "The voices are telling me I am worthless." The most therapeutic response is:',
      opts: [
        '"There are no voices — that is just your illness talking."',
        '"I do not hear any voices, but I can see this is frightening for you. What are they saying?"',
        '"Try to ignore them and they will go away."',
        '"What makes you think you are worthless?"'
      ],
      a: 1,
      why: '<p>Option B does three things correctly: it <strong>presents reality gently</strong> without arguing, <strong>validates the emotion</strong> rather than the perception, and <strong>assesses the content</strong> of the hallucination — essential, because command hallucinations to harm self or others change the plan of care immediately.</p>' +
        '<p>Option A is dismissive and damages trust. Option C is false reassurance and impossible advice. Option D reinforces the delusional content by treating "worthless" as a premise to explore rather than a symptom to assess.</p>' +
        '<p>The rule: never argue with a hallucination, and never pretend to share it.</p>',
      refs: [yt('therapeutic communication hallucinations nursing psychiatric', 'Video — Responding to hallucinations')]
    },

    /* ---------------- ATI COMMUNITY HEALTH ---------------- */
    {
      id: 'aticom-01', exam: 'ati-community', section: 'prevention', difficulty: 'moderate', type: 'mcq',
      q: 'A nurse organises mammography screening at a community centre. This is an example of which level of prevention?',
      opts: ['Primary', 'Secondary', 'Tertiary', 'Quaternary'],
      a: 1,
      why: '<p><strong>Secondary prevention</strong> is early detection of existing but asymptomatic disease. Screening — mammography, blood pressure checks, colonoscopy, Pap tests — is the defining example.</p>' +
        '<p>The three levels, with the test that separates them:</p>' +
        '<ul><li><strong>Primary</strong> — prevents disease occurring at all: immunisation, health education, seat belts</li>' +
        '<li><strong>Secondary</strong> — detects disease early, before symptoms: all screening</li>' +
        '<li><strong>Tertiary</strong> — limits disability once disease is established: cardiac rehab, stroke rehabilitation</li></ul>' +
        '<p>Ask "has the disease already started, and does the person know?" — that resolves nearly every item of this type.</p>',
      refs: [{ t: 'CDC — Picture of America: Prevention', u: 'https://www.cdc.gov/pictureofamerica/', k: 'scholarly' }]
    },
    {
      id: 'aticom-02', exam: 'ati-community', section: 'epi', difficulty: 'hard', type: 'mcq',
      q: 'In a town of 40,000, there were 80 new cases of a disease during one year. This figure describes the:',
      opts: ['Prevalence rate', 'Incidence rate', 'Mortality rate', 'Attack rate'],
      a: 1,
      why: '<p><strong>Incidence</strong> counts <em>new</em> cases arising in a population over a defined period — here 80 per 40,000 per year, or 2 per 1,000 per year.</p>' +
        '<p><strong>Prevalence</strong> counts <em>all</em> existing cases at a point in time, new and old together. The mnemonic that holds: <strong>i</strong>ncidence for <strong>i</strong>ncoming.</p>' +
        '<p>Incidence measures risk of acquiring disease, which is why it is the right measure for outbreak investigation. Prevalence measures burden, which is why it drives resource planning.</p>',
      refs: [{ t: 'CDC — Principles of Epidemiology in Public Health Practice', u: 'https://www.cdc.gov/csels/dsepd/ss1978/index.html', k: 'scholarly' }]
    },

    /* ---------------- ATI LEADERSHIP ---------------- */
    {
      id: 'atild-01', exam: 'ati-leadership', section: 'delegation', difficulty: 'hard', type: 'mcq',
      q: 'Which assignment is most appropriate for a licensed practical nurse (LPN/LVN)?',
      opts: [
        'Developing the plan of care for a new admission',
        'Administering oral medications to a stable client with pneumonia',
        'Performing the initial admission assessment',
        'Providing discharge teaching about a new insulin regimen'
      ],
      a: 1,
      why: '<p>LPNs may perform <strong>stable, predictable care within their scope</strong> — including most medication administration, dressing changes and routine monitoring.</p>' +
        '<p>What stays with the RN: <strong>initial assessment</strong>, <strong>care planning</strong>, <strong>evaluation</strong>, and <strong>teaching</strong>. Options A, C and D are all reserved on that basis.</p>' +
        '<p>The tiering that resolves nearly every item: UAP get standard tasks on stable clients; LPNs get stable clients with predictable outcomes; RNs keep assessment, planning, evaluation, teaching, and anything unstable.</p>' +
        '<p>Scope does vary by state, and the exam tests the national baseline.</p>',
      refs: [{ t: 'NCSBN — National Guidelines for Nursing Delegation', u: 'https://www.ncsbn.org/public-files/NGND-PosPaper_06.pdf', k: 'scholarly' }]
    },
    {
      id: 'atild-02', exam: 'ati-leadership', section: 'quality', difficulty: 'moderate', type: 'mcq',
      q: 'After a medication error reaches a client, the facility conducts a root cause analysis. The primary purpose is to:',
      opts: [
        'Determine which staff member should be disciplined',
        'Identify system failures that allowed the error and prevent recurrence',
        'Satisfy the client\'s family that action was taken',
        'Document the event for the client\'s legal record'
      ],
      a: 1,
      why: '<p>Root cause analysis is a <strong>systems</strong> tool. It asks how the process permitted the error — look-alike packaging, an interruption during administration, an ambiguous order, understaffing — so the process can be changed.</p>' +
        '<p>It is explicitly <strong>not</strong> a disciplinary process. Blame-focused review suppresses reporting, which means the next error goes unseen. This is the "just culture" principle the exam tests.</p>' +
        '<p>Incident reports serve quality improvement and, importantly, are not filed in the client\'s medical record.</p>',
      refs: [{ t: 'AHRQ Patient Safety Network — Root Cause Analysis', u: 'https://psnet.ahrq.gov/primer/root-cause-analysis', k: 'scholarly' }]
    },

    /* ---------------- ATI NUTRITION ---------------- */
    {
      id: 'atinu-01', exam: 'ati-nutrition', section: 'diets', difficulty: 'moderate', type: 'mcq',
      q: 'A client with coeliac disease should avoid which food?',
      opts: ['Rice cakes', 'Barley soup', 'Corn tortillas', 'Baked potato'],
      a: 1,
      why: '<p>Coeliac disease requires strict lifelong avoidance of <strong>gluten</strong>, found in <strong>wheat, barley and rye</strong>. Barley soup contains gluten.</p>' +
        '<p>The mnemonic <strong>BROW</strong> — Barley, Rye, Oats, Wheat — captures the group. Oats are naturally gluten-free but are usually cross-contaminated in processing, so only certified gluten-free oats are safe.</p>' +
        '<p>Rice, corn and potato are all naturally gluten-free and are the staples these clients build meals around.</p>',
      refs: [{ t: 'NIDDK — Coeliac Disease', u: 'https://www.niddk.nih.gov/health-information/digestive-diseases/celiac-disease', k: 'scholarly' }]
    },
    {
      id: 'atinu-02', exam: 'ati-nutrition', section: 'diets', difficulty: 'moderate', type: 'mcq',
      q: 'A client on warfarin asks which foods to limit. Which food group is highest in vitamin K?',
      opts: ['Citrus fruits', 'Dark leafy greens', 'Red meat', 'Dairy products'],
      a: 1,
      why: '<p><strong>Dark leafy greens</strong> — kale, spinach, collards, Swiss chard, broccoli — are by far the richest dietary source of vitamin K.</p>' +
        '<p>The teaching is <strong>consistency rather than elimination</strong>. A client who eats a steady amount of greens can be dosed accurately around it. It is the sudden change — a new salad habit, or stopping one — that destabilises the INR.</p>' +
        '<p>Citrus is notable for vitamin C; red meat for iron and B12; dairy for calcium and vitamin D.</p>',
      refs: [R.dietary, R.statpearls]
    },
    {
      id: 'atinu-03', exam: 'ati-nutrition', section: 'lifespan', difficulty: 'moderate', type: 'mcq',
      q: 'Which laboratory value is the best indicator of long-term protein status?',
      opts: ['Haemoglobin', 'Serum albumin', 'White blood cell count', 'Serum sodium'],
      a: 1,
      why: '<p><strong>Serum albumin</strong> reflects protein status over roughly the preceding three weeks, because its half-life is about 21 days. Normal is 3.5 to 5.0 g/dL.</p>' +
        '<p><strong>Prealbumin</strong>, with a half-life of about two days, is the better marker for <em>recent</em> or rapidly changing status — a distinction the exam tests directly.</p>' +
        '<p>Interpret albumin with care: it also falls in liver disease, nephrotic syndrome, and acute inflammation, none of which are malnutrition.</p>',
      refs: [R.statpearls, yt('albumin prealbumin nutritional status assessment', 'Video — Albumin and prealbumin')]
    }
  );

})();
